import { render } from "./Producto.vue?vue&type=template&id=95ad9454&scoped=true"
import script from "./Producto.vue?vue&type=script&lang=js"
export * from "./Producto.vue?vue&type=script&lang=js"

import "./Producto.vue?vue&type=style&index=0&id=95ad9454&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95ad9454"]])

export default __exports__